export const refreshCacheAndReload = async () => {
  try {
    // Очистка Cache API
    if (globalThis?.caches) {
      const { caches } = globalThis;
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(n => caches.delete(n)));
    }

    // Удаление Service Workers (если есть)
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(reg => reg.unregister()));
    }

    // Простая перезагрузка
    globalThis.location.reload();
  } catch (error) {
    console.error('Failed to refresh cache and reload:', error);
    globalThis.location.reload();
  }
};
